import { BarProps } from '../../ts'
import Controls from './includes/Controls'
import Heading from './includes/Heading'
import Tags from './includes/Tags'

function Bar({ count, filters, title }: BarProps) {
  return (
    <>
      <div className="flex flex-col space-y-4 xl:space-y-0 xl:flex-row xl:items-center">
        <Heading title={title} />
        <Controls count={count} />
      </div>
      <Tags filters={filters} />
    </>
  )
}

export default Bar
